import { combineReducers } from 'redux'

import { makeCommunicationByIdReducer } from 'shared/utils/communication/reducer/makeCommunicationByIdReducer'
import { makeCommunicationReducer } from 'shared/utils/communication/reducer/makeCommunicationReducer'

import * as actions from '../actions'
import { IBonusSystemState } from '../types'

export default combineReducers<IBonusSystemState['communications']>({
  exchangeBonusBalanceToBalance: makeCommunicationReducer(actions.exchangeBonusBalanceToBalance),
  getUserPromotions: makeCommunicationReducer(actions.getUserPromotions),
  changeActiveUserPromotion: makeCommunicationByIdReducer(actions.changeActiveUserPromotion),
  getMoneyFromPromotion: makeCommunicationByIdReducer(actions.getMoneyFromPromotion),
  getUserActivePromotions: makeCommunicationReducer(actions.getUserActivePromotions),
  getUserPromotionsPoll: makeCommunicationReducer(actions.getUserPromotionsPoll),
})
